import { trackPageView as gaTrackPageView } from '../../../default/analytics.js'
import { trackPageView as gtmTrackPageView } from '../../../default/google_tag_manager.js'

const namespaced = true

const state = {
  display: null
}

const mutations = {
  displayCart(state) {
    document.querySelector('body').classList.add('nav-cart-displaying')
    gaTrackPageView('/cart')
    gtmTrackPageView(`https://${window.location.host}/cart`, 'Cart Slideout')
    state.display = true
  },
  hideCart(state) {
    document.querySelector('body').classList.remove('nav-cart-displaying')
    state.display = false
  }

}

const getters = {
  getCartDisplay: (state) => {
    return state.display
  },
  openClass: (state) => {
    if (state.display == true) {
      return 'display'
    } else if (state.display == false) {
      return 'closed'
    } else {
      return ''
    }
  }
}


export default {
  namespaced,
  state,
  mutations,
  getters
}
